import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommonField } from '../models/Field';
import { RenderableFieldGroup } from '../models/FieldGroup/FieldGroup';

@Component({
  selector: 'field-group',
  template: `<div
    class="field-group"
    [style.display]="isVisible && !isEmpty ? null : 'none'"
  >
    <div
      *ngIf="fieldGroup.isHeaderVisible"
      class="field-group__header"
      (click)="isCollapsed = !isCollapsed"
      [ngClass]="hasErrors && isCollapsed ? 'ng-invalid ng-touched' : ''"
      [style.margin-bottom]="fieldGroup.description ? '0' : '2rem'"
    >
      <span class="collapse-indicator">{{ isCollapsed ? '▶' : '▼' }}</span>
      {{ fieldGroup.label || '' }}
    </div>
    <div
    [style.display]="isCollapsed ? 'none' : 'block'"
    class="row field-group__body"
    >
    <div *ngIf="fieldGroup.isHeaderVisible && fieldGroup.description" class="field-group__description">{{ fieldGroup.description }}</div>
    <ng-container *ngFor="let column of fieldGroup.fieldLines">
      <field-line
        *ngIf="column.isVisible"
        [form]="form"
        [allFormFields]="allFormFields"
        [column]="column.fields"
        class="{{
          'col-xs-12 ' +
            ('col-md-' +
              (column.widthModifier ? column.widthModifier : '12'))
        }}"
        ></field-line>
      </ng-container>
    </div>
  </div>`,
})
export class FieldGroupComponent implements OnInit, OnDestroy {
  @Input() fieldGroup: RenderableFieldGroup;
  @Input() form: FormGroup;
  @Input() allFormFields: CommonField[];

  isCollapsed: boolean = false;
  private isVisible = true;
  private isEmpty = false
  private hasErrors: boolean = false;
  private subscriptions: Subscription[] = []

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  calcHasError() {
    return this.fieldGroup.fieldLines.find((col) =>
      Boolean(col.fields.find(
        (field) =>
          this.form.controls[field.field.key].invalid &&
          this.form.controls[field.field.key].touched
      ))
    )
      ? true
      : false;
  }

  calcIsVisible() {
    const isVisible = this.fieldGroup.isVisible;
    return typeof isVisible === 'function' ? isVisible(this.form) : isVisible
  }

  ngOnInit() {
    this.isVisible = this.calcIsVisible();
    this.hasErrors = this.calcHasError();
    this.subscriptions.push(this.form.valueChanges.subscribe(() => {
      this.isVisible = this.calcIsVisible();
      this.hasErrors = this.calcHasError();
    }))
    console.log(this.allFormFields);

  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => { s.unsubscribe() })
    this.subscriptions = [];
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/components/field-group.component.ts